/** @format */

import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/store";

export const selectCircleInvitations = (state: RootState) =>
	state.circleInvitation.invitations;

export const selectCircleInvitationIsLoading = (state: RootState) =>
	state.circleInvitation.isLoading;

export const selectCircleInvitationIsAccepting = (state: RootState) =>
	state.circleInvitation.isAccepting;

export const selectCircleInvitationIsDenying = (state: RootState) =>
	state.circleInvitation.isDenying;

export const selectCircleInvitationError = (state: RootState) =>
	state.circleInvitation.error;

export const selectCircleInvitationAcceptError = (state: RootState) =>
	state.circleInvitation.acceptError;

export const selectCircleInvitationDenyError = (state: RootState) =>
	state.circleInvitation.denyError;

export const selectAcceptedInvitations = (state: RootState) =>
	state.circleInvitation.invitations.filter((inv) =>
		[
			"ACCEPTED_AWAITING_VERIFICATION",
			"ACCEPTED_UNDER_REVIEW",
			"APPROVED_ADDING_MEMBER",
			"COMPLETED_MEMBER_ADDED",
		].includes(inv.status),
	);

/**
 * Invitations the user can still act on (accept/deny), newest first.
 * Same rule as ViewCircleInvitations' isActionable, plus guards against
 * expired invites and circles that are banned/inactive.
 */
const selectOpenInvitationsByStatus = (status: string) =>
	createSelector([selectCircleInvitations], (invitations) => {
		const now = Date.now();
		return invitations
			.filter(
				(inv) =>
					inv.status === status &&
					(!inv.expiresAt || new Date(inv.expiresAt).getTime() > now) &&
					inv.circle?.isBanned !== true &&
					inv.circle?.isActive !== false,
			)
			.sort(
				(a, b) =>
					new Date(b.created_At || 0).getTime() -
					new Date(a.created_At || 0).getTime(),
			);
	});

export const selectPendingCircleInvitations = selectOpenInvitationsByStatus(
	"PENDING_INVITEE_ACTION",
);

/** Accepted before verifying; a verified user can now finish joining. */
export const selectAwaitingVerificationInvitations =
	selectOpenInvitationsByStatus("ACCEPTED_AWAITING_VERIFICATION");
